import React, { useMemo } from 'react';
import { useModalContext } from 'contexts/modal';
import Modal from 'components/modal-dialog/modal';
import useKeyboard from 'hooks/use-keyboard';
import useQueryParams from 'hooks/use-query-params';
import { ModalOpeners } from 'types/modal';

import type { ListingOptions } from 'components/modal-dialog/listing';

export default function ModalDialog() {
  const {
    modals,
    activeModal,
    openModal,
    closeModal,
    closeAllModals,
    changeUrlOnModal,
    closeModalByName,
    isCrawler,
  } = useModalContext();

  useKeyboard(() => {
    if (activeModal) {
      closeModal();
    }
  }, 'esc');

  useQueryParams(params => openModal('listing', { ...params, updateHistory: false } as ListingOptions), ModalOpeners.LISTING_ID);

  // Memoize the modal components array to prevent unnecessary re-renders
  const modalComponents = useMemo(() => {
    if (!modals.length) {
      return null;
    }
    return modals.map(({ name, options }, index) => (
      <Modal
        key={index}
        name={name}
        options={options}
        openModal={openModal}
        closeModal={closeModal}
        closeAllModals={closeAllModals}
        closeModalByName={closeModalByName}
        isActiveModal={modals.length - 1 === index}
        changeUrlOnModal={changeUrlOnModal}
        isCrawler={isCrawler}
      />
    ));
  }, [modals, openModal, closeModal, closeAllModals, closeModalByName, changeUrlOnModal, isCrawler]);

  return <>{modalComponents}</>;
}
